import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Helmet } from 'react-helmet';
// Import all logo images (keep existing imports)
import logo41 from "../../assets/img/axios.jpg";
import logo42 from "../../assets/img/circle-logo-ondark.png";
import logo43 from "../../assets/img/riglab.png";
import logo1 from "../../assets/img/l1.png";
import logo2 from "../../assets/img/l2.png";
import logo3 from "../../assets/img/l3.png";
import logo4 from "../../assets/img/l4.png";
import logo5 from "../../assets/img/l5.png";
import logo6 from "../../assets/img/l6.png";
import logo7 from "../../assets/img/l7.png";
import logo8 from "../../assets/img/l8.svg";
import logo9 from "../../assets/img/l9.png";
import logo10 from "../../assets/img/l10.png";
import logo11 from "../../assets/img/l11.png";
import logo12 from "../../assets/img/l12.png";
import logo13 from "../../assets/img/l13.png";
import logo14 from "../../assets/img/l14.png";
import logo15 from "../../assets/img/l15.png";
import logo16 from "../../assets/img/l16.png";
import logo17 from "../../assets/img/l17.svg";
import logo18 from "../../assets/img/l18.png";
import logo19 from "../../assets/img/l19.svg";
import logo20 from "../../assets/img/l20.svg";
import logo21 from "../../assets/img/l21.png";
import logo22 from "../../assets/img/l22.png";
import logo23 from "../../assets/img/l23.svg";
import logo24 from "../../assets/img/l24.svg";
import logo25 from "../../assets/img/l25.png";
import logo26 from "../../assets/img/l26.png";
import logo28 from "../../assets/img/l28.png";
import logo27 from "../../assets/img/l30.svg";
import logo29 from "../../assets/img/l31.svg";
import logo30 from "../../assets/img/l32.jpg";
import logo31 from "../../assets/img/LEADPOINT.png";
import logo32 from "../../assets/img/Podha_Logo.png";
import logo33 from "../../assets/img/axir.jpg";
import logo34 from "../../assets/img/Xenea.png";
import logo35 from "../../assets/img/image.png";
import logo44 from "../../assets/img/enit.png";


const TrustedBy = () => {
    const [showAll, setShowAll] = useState(true);

    const allLogos = [
        
        { id: 42, name: 'Circle', img: logo42 },
        { id: 1, name: 'Infini', img: logo1 },
        { id: 2, name: 'HackQuest', img: logo2 },
        { id: 3, name: 'Flex Protocol', img: logo3 },
        { id: 41, name: 'Axios', img: logo41 },
        { id: 32, name: 'Hyperlane', img: logo28 },
        { id: 30, name: 'Stork', img: logo26 },
        { id: 30, name: 'Stork', img: logo27 },
        { id: 44, name: 'eni', img: logo44 },
        { id: 43, name: 'Riglab', img: logo43 },

        { id: 31, name: '', img: logo29 },
        { id: 32, name: '', img: logo30 },
        { id: 35, name: 'Xenea', img: logo34 },
        { id: 8, name: 'FUEL', img: logo8 },
        { id: 33, name: 'Leadpoint', img: logo31 },
        { id: 34, name: 'Podha', img: logo32 },
        { id: 5, name: 'Aibox', img: logo5 },
        { id: 6, name: 'gmeme', img: logo6 },
        { id: 7, name: 'HackenProof', img: logo7 },
        { id: 9, name: 'SwanChain', img: logo9 },
        { id: 10, name: 'OpenBuild', img: logo10 },
        { id: 11, name: 'TabiChain', img: logo11 },
        { id: 12, name: 'B² Network', img: logo12 },
        { id: 13, name: 'InitVerse', img: logo13 },
        { id: 14, name: 'SOEX', img: logo14 },
        { id: 4, name: 'MoveFlow', img: logo4 },
        { id: 15, name: 'OKX', img: logo15 },
        { id: 16, name: 'Bitget', img: logo16 },
        { id: 17, name: 'bugrap', img: logo17 },
        { id: 18, name: 'CoreDao', img: logo23 },
        { id: 19, name: 'RedStone', img: logo20 },
        { id: 21, name: 'OxiSwap', img: logo22 },
        { id: 22, name: 'Griffy', img: logo18 },
        { id: 23, name: 'Fluid Protocol', img: logo21 },
        { id: 24, name: 'Miraly', img: logo19 },
        { id: 25, name: 'Lync World', img: logo25 },
        { id: 28, name: 'Xenea IO', img: logo24 },
        { id: 29, name: 'Axir', img: logo33 },
        { id: 36, name: '', img: logo35 },
    ];

    return (
        <>
        <Helmet>
            {/* Structured Data for AI Understanding - Only non-conflicting meta tags */}
            <script type="application/ld+json">
                {JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "Organization",
                    "name": "Safe Edges",
                    "description": "Premier blockchain and cybersecurity firm dedicated to fortifying digital assets",
                    "url": "https://safeedges.in",
                    "logo": "https://safeedges.in/logo.png",
                    "sameAs": [
                        "https://twitter.com/SafeEdges",
                        "https://www.linkedin.com/company/safe-edges",
                        "https://t.me/bugtester25",
                        "https://safe-edges.medium.com/"
                    ],
                    "hasOfferCatalog": {
                        "@type": "OfferCatalog",
                        "name": "Blockchain Security Services",
                        "itemListElement": [
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "Smart Contract Audit",
                                    "description": "Comprehensive security audit of blockchain smart contracts"
                                }
                            },
                            {
                                "@type": "Offer",
                                "itemOffered": {
                                    "@type": "Service",
                                    "name": "AI & MCP Audit",
                                    "description": "Security audit of AI and Model Context Protocol implementations"
                                }
                            }
                        ]
                    },
                    "knowsAbout": [
                        "Blockchain Security",
                        "Smart Contract Auditing",
                        "DeFi Security",
                        "Web3 Security",
                        "Cryptocurrency Security"
                    ]
                })}
            </script>
        </Helmet>

        <section className="py-24 bg-black">

            {/* Elegant header with minimal design */}
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
                className="max-w-3xl mx-auto mb-20 text-center"
            >
                <h2 className="text-3xl md:text-5xl font-bold text-center mb-12">
                    Trusted by <span className="bg-gradient-to-r from-[#00A99E] to-white bg-clip-text text-transparent">Industry Leaders</span>
                </h2>
                <p className="mb-6 text-base sm:text-lg text-gray-300 font-light">Our Official Partners and Clients</p>
                <div className="w-16 h-1 mx-auto mb-8 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full"></div>
            </motion.div>

            {/* Logo showcase with elegant design */}
            <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
                className="relative"
            >
                <div className="relative max-w-5xl mx-auto px-2 sm:px-6 py-8 sm:py-12 overflow-hidden rounded-3xl backdrop-blur-sm bg-black/30 z-10">
                    {/* Logo grid with elegant spacing */}
                    <div className="flex flex-wrap border-l-2 border-t-2 border-white z-10 relative">
                        <AnimatePresence>
                            {(showAll ? allLogos : allLogos.slice(0, 15)).map((item, index) => (
                                <motion.div
                                    key={item.id}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -20 }}
                                    transition={{
                                        duration: 0.5,
                                        delay: index * 0.05,
                                        ease: "easeOut"
                                    }}
                                    viewport={{ once: true }}
                                    className="flex items-center justify-center bg-black aspect-square border-r-2 border-b-2 border-white w-1/2 sm:w-1/4 md:w-1/5 lg:w-1/6"
                                >
                                        <motion.div
                                            whileHover={{
                                                scale: 1.08,
                                                boxShadow: "0 0 24px 0 rgba(59,130,246,0.25)",
                                                zIndex: 2
                                            }}
                                            whileFocus={{
                                                scale: 1.08,
                                                boxShadow: "0 0 24px 0 rgba(59,130,246,0.25)",
                                                zIndex: 2
                                            }}
                                            className="flex items-center justify-center w-14 h-14 sm:w-20 sm:h-20 md:w-24 md:h-24 p-2 sm:p-4 transition-all duration-300 bg-black"
                                            tabIndex={0}
                                        >
                                            <img
                                                src={item.img}
                                                alt={`${item.name || 'Partner'} logo`}
                                                width="120"
                                                height="120"
                                                loading="lazy"
                                                decoding="async"
                                            className={`object-contain w-full h-full transition-all duration-300 ${
                                                item.name === 'Podha'
                                                    ? 'scale-[1.35] hover:scale-[1.45]'
                                                    : item.name === 'Leadpoint'
                                                        ? 'scale-125 hover:scale-[1.30]'
                                                        : 'scale-110 hover:scale-115'
                                            }`}
                                            style={{
                                                filter: item.name === 'Podha' ? 'brightness(0) saturate(100%) invert(1)' : undefined
                                            }}
                                            />
                                        </motion.div>
                                </motion.div>
                            ))}
                        </AnimatePresence>
                    </div>

                    {/* Elegant minimal button */}
                    {allLogos.length > 15 && (
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.6 }}
                            className="mt-16 text-center z-20 relative"
                        >
                            <button
                                onClick={() => setShowAll(!showAll)}
                                aria-label={showAll ? "Show fewer partners" : "Show all partners"}
                                className="px-8 py-3 text-sm font-semibold tracking-wider uppercase transition-all duration-300 border rounded-full text-white bg-gradient-to-r from-[#00A99E] to-white text-black border-[#00A99E]/30 shadow-xl hover:bg-[#00A99E]/90 hover:border-[#00A99E]/50 hover:shadow-2xl hover:shadow-[#00A99E]/25 focus:outline-none focus:ring-2 focus:ring-[#00A99E] min-h-[44px] min-w-[120px]"
                            >
                                {showAll ? 'Show Less' : 'Show All'}
                            </button>
                        </motion.div>
                    )}
                </div>
            </motion.div>
        </section>

        {/* Hidden content for AI crawlers - accessible without JavaScript */}
        <div className="sr-only" aria-hidden="true">
            <h2>Safe Edges Blockchain Security Partners and Clients</h2>
            <p>Safe Edges is a premier blockchain and cybersecurity firm trusted by industry leaders including:</p>
            <ul>
                {allLogos.map((item) => (
                    <li key={item.id}>
                        {item.name} - Official partner
                    </li>
                ))}
            </ul>
            <p>Our services include smart contract auditing, DeFi security, Web3 security, and AI & MCP audit services.</p>
            <p>Contact us at info@safeedges.in for blockchain security solutions.</p>
        </div>
        
        <style>{`
            @keyframes scroll {
                0% {
                    transform: translateX(0);
                }
                100% {
                    transform: translateX(-50%);
                }
            }
            
            .animate-scroll {
                animation: scroll 20s linear infinite;
            }
            
            @keyframes flow {
                0% {
                    transform: translateX(0);
                }
                100% {
                    transform: translateX(-50%);
                }
            }
            
            .animate-flow {
                animation: flow 30s linear infinite;
            }

            /* Border shimmer animation */
            @keyframes shimmerX {
                0% { background-position: 200% 0; }
                100% { background-position: -200% 0; }
            }
            @keyframes shimmerY {
                0% { background-position: 0 200%; }
                100% { background-position: 0 -200%; }
            }
            .shimmer-x {
                background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0) 100%);
                background-size: 200% 100%;
                animation: shimmerX 2.2s linear infinite;
            }
            .shimmer-y {
                background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.9) 50%, rgba(255,255,255,0) 100%);
                background-size: 100% 200%;
                animation: shimmerY 2.2s linear infinite;
            }
        `}</style>
        </>
    );
};

export default TrustedBy;